"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LargeTitle", {
    enumerable: true,
    get: function() {
        return LargeTitle;
    }
});
const _createPreset = require("../createPreset");
const _useLargeTitleStylesstyles = require("./useLargeTitleStyles.styles");
const LargeTitle = (0, _createPreset.createPreset)({
    useStyles: _useLargeTitleStylesstyles.useLargeTitleStyles,
    className: _useLargeTitleStylesstyles.largeTitleClassNames.root,
    displayName: 'LargeTitle'
});
